var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.098 27.0192C117.223 23.9968 123.086 25.5677 125.147 30.2478L140.304 64.6588C140.878 65.9638 141.792 67.0914 142.949 67.925L173.456 89.9045C177.606 92.8939 177.923 98.9552 174.109 102.362L146.066 127.41C145.003 128.36 144.212 129.577 143.777 130.935L132.301 166.741C130.74 171.611 125.073 173.787 120.655 171.212L88.1668 152.281C86.9347 151.564 85.5331 151.188 84.1072 151.194L46.5066 151.344C41.3927 151.364 37.5729 146.647 38.6561 141.65L46.6207 104.902C46.9228 103.508 46.8468 102.059 46.4008 100.705L34.6386 64.9908C33.0389 60.1336 36.3447 55.0431 41.4327 54.5289L78.843 50.748C80.2618 50.6046 81.6164 50.0846 82.7667 49.2418L113.098 27.0192Z",
    fill: "#020410",
    stroke: "#FF0000",
    strokeWidth: 12
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5456,
    cy: 58.5173,
    r: 3.39799,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.7868,
    cy: 102.691,
    r: 3.39799,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.1235,
    cy: 127.61,
    r: 3.39799,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5114,
    cy: 151.396,
    r: 3.39799,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.1647,
    cy: 151.396,
    r: 3.39799,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.818,
    cy: 163.855,
    r: 3.39799,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.002,
    cy: 152.528,
    r: 3.39799,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.931,
    cy: 128.742,
    r: 3.39799,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.053,
    cy: 112.885,
    r: 3.39799,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.921,
    cy: 81.1705,
    r: 3.39799,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.665,
    cy: 67.5785,
    r: 3.39799,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5014,
    cy: 50.5885,
    r: 3.39799,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.8481,
    cy: 52.8539,
    r: 3.39799,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.8581,
    cy: 80.0379,
    r: 3.39799,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.8893,
    cy: 38.1292,
    r: 3.39799,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.604,
    cy: 44.9252,
    r: 3.39799,
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.159,
    cy: 171.784,
    r: 3.39799,
    fill: "white"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.363,
    cy: 25.67,
    r: 3.39799,
    fill: "white"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.996,
    cy: 97.0278,
    r: 3.39799,
    fill: "white"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.209,
    cy: 147.998,
    r: 3.39799,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.568 96.936C84.672 96.936 83.824 96.696 83.024 96.216C82.224 95.704 81.568 95.032 81.056 94.2C80.576 93.368 80.336 92.44 80.336 91.416C80.336 89.88 80.864 88.568 81.92 87.48C82.976 86.36 84.256 85.8 85.76 85.8C87.136 85.8 88.336 86.312 89.36 87.336C90.384 88.36 90.896 89.64 90.896 91.176C90.896 92.104 90.656 93.016 90.176 93.912C89.696 94.808 89.04 95.544 88.208 96.12C87.408 96.664 86.528 96.936 85.568 96.936ZM85.568 117.288C84.672 117.288 83.824 117.048 83.024 116.568C82.224 116.056 81.568 115.384 81.056 114.552C80.576 113.72 80.336 112.792 80.336 111.768C80.336 110.232 80.864 108.92 81.92 107.832C82.976 106.712 84.256 106.152 85.76 106.152C87.136 106.152 88.336 106.664 89.36 107.688C90.384 108.712 90.896 109.992 90.896 111.528C90.896 112.456 90.656 113.368 90.176 114.264C89.696 115.16 89.04 115.896 88.208 116.472C87.408 117.016 86.528 117.288 85.568 117.288ZM106.32 117.192C103.824 117.192 101.536 116.568 99.4558 115.32C97.3758 114.072 95.7278 112.408 94.5118 110.328C93.3278 108.216 92.7358 105.976 92.7358 103.608C92.7358 100.984 93.4078 98.712 94.7518 96.792C96.1278 94.872 97.8398 93.416 99.8878 92.424C101.968 91.432 104.064 90.936 106.176 90.936C108.928 90.936 111.328 91.464 113.376 92.52C115.424 93.544 117.008 95.016 118.128 96.936C119.248 98.856 119.808 101.096 119.808 103.656C119.808 106.184 119.216 108.488 118.032 110.568C116.848 112.616 115.216 114.232 113.136 115.416C111.088 116.6 108.816 117.192 106.32 117.192ZM106.608 109.032C107.952 109.032 109.056 108.6 109.92 107.736C110.816 106.872 111.264 105.688 111.264 104.184C111.264 102.744 110.848 101.528 110.016 100.536C109.184 99.544 107.952 99.048 106.32 99.048C104.88 99.048 103.68 99.528 102.72 100.488C101.792 101.448 101.328 102.632 101.328 104.04C101.328 105.48 101.824 106.68 102.816 107.64C103.808 108.568 105.072 109.032 106.608 109.032Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.09c03c61480783be4e44c4b0a814627b.svg";
export { ForwardRef as ReactComponent };